export const EXPENSES = 'EXPENSES';

export const applicationReasonOptions = [
  { label: 'For everyday expenses and large one-off purchases', value: EXPENSES },
  { label: 'For business expenses', value: 'BUSINESS' },
  { label: 'For debt consolidation', value: 'DEBT_CONSOLIDATION' },
];
